<template>
    <div class="filter-item">
        <slot />
    </div>
</template>

<style lang="scss">
 .filter-item {
     display: flex;
     align-items: center;
     justify-content: center;

     @include body1-semibold;

     label {
         display: flex;
         background: $chip-bg;
         border-radius: px2rem(24);
         padding: 0 px2rem(24);
         text-transform: uppercase;
         white-space: nowrap;
         cursor: pointer;
         height: px2rem(40);
         transition: background 400ms ease-in;
         align-items: center;
     }

     // > input:checked + label : For what reasons ever, this seems to be buggy in browser...
     &.filter-item-active {
         label {
             background-color: $chip-bg-checked;
         }
     }

     input {
         display: none;
     }
 }

 .filter-item-icon {
     display: flex;
     align-items: center;
     width: px2rem(15);
     height: px2rem(15);
     margin-inline-end: px2rem(5);

     > svg {
         display: block;
         width: 100%;
         height: 100%;
     }
 }
</style>
